import React, {useState} from 'react';
import Header from './components/Header';
import Formulario from './components/Formulario';
import Resumen from './components/Resumen';
import Resultado from './components/Resultado';
import Spinner from './components/Spinner';

import styled from '@emotion/styled';


const Contenedor=styled.div`
max-width:600px;
margin:0 auto;
`;
const ContenedorFormulario=styled.div`
background-color:#FFF;
padding:3rem;
`;
function App() {

  const [resumen, guardarResumen]=useState({
    cotizacion: 0,
    datos:{
      marca:'',
      year:'',
      plan:''
    }
  });

  //state spinner:
  const [cargando,guardarCargando]=useState(false);
  //extraigo datos:
  const{datos,cotizacion}=resumen;

  //const {datos}=resumen;
  //{datos? (<Resumen/>):null}
  return (
    <Contenedor>
      <Header
        titulo="cotizador de seguros"
      />
      <ContenedorFormulario>
      <Formulario
      guardarResumen={guardarResumen}
      guardarCargando={guardarCargando}
      />
      {cargando?<Spinner/>:null}
      {cargando?null:<Resumen
      datos={datos}
      />}
      
      {!cargando ? 
      <Resultado
      cotizacion={cotizacion}
      />:null}
     
      </ContenedorFormulario>
    </Contenedor>
  );
}

export default App;
